import { render } from "./ProductIndex.vue?vue&type=template&id=73788704&scoped=true"
import script from "./ProductIndex.vue?vue&type=script&lang=js"
export * from "./ProductIndex.vue?vue&type=script&lang=js"

import "./ProductIndex.vue?vue&type=style&index=0&id=73788704&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73788704"]])

export default __exports__